"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.retrieve = exports.clear = exports.isLSAvailable = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
function isLSAvailable() {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.getItem(test);
        localStorage.removeItem(test);
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.isLSAvailable = isLSAvailable;
function clear(key) {
    localStorage.removeItem(key);
}
exports.clear = clear;
function retrieve(key) {
    var value = localStorage.getItem(key);
    if (!firefly_utilities_helper_ts_1.isNullOrUndefined(value)) {
        return JSON.parse(value);
    }
}
exports.retrieve = retrieve;
function store(key, value) {
    if (firefly_utilities_helper_ts_1.isObject(value) || firefly_utilities_helper_ts_1.isArray(value)) {
        localStorage.setItem(key, JSON.stringify(value));
    }
}
exports.store = store;
